<template>
	<Modal v-model="show" type="drawer-right" hasCloseIcon :width="1000">
		<div slot="header">
			{{subject ? subject.name : ''}}<template v-if="subject && subject.code"> [{{subject.code}}]</template> - 科目详细
		</div>
		<div class="p-10px">
			<div class="mb-10px clearfix">
				<div class="float-right">
					<Button size="s" icon="fa fa-refresh" @click="loadData">刷新</Button>
				</div>
			</div>
			<table class="cus-table">
				<thead class="header">
				<tr>
					<td width="100">日期</td>
					<td width="90">凭证字号</td>
					<td width="150">科目</td>
					<td>摘要</td>
					<td width="110" class="text-right">借方</td>
					<td width="110" class="text-right">贷方</td>
					<td width="60" class="text-center">方向</td>
					<td width="110" class="text-right">余额</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item, index) in datalist" :key="index">
					<td>{{item.voucherDate}}</td>
					<td>
						<router-link v-if="item.voucherId" :to="{name:'VoucherForm',params:{voucherId:item.voucherId}}" class="primary-color">{{item.word}}-{{item.code}}</router-link>
						<template v-else>{{item.word}}-{{item.code}}</template>
					</td>
					<td>{{item.subjectName}}</td>
					<td>{{item.summary}}</td>
					<td class="text-right">{{item.debitAmount|numFormat}}</td>
					<td class="text-right">{{item.creditAmount|numFormat}}</td>
					<td class="text-center">{{item.balanceDirection}}</td>
					<td class="text-right">{{item.balance|numFormat}}</td>
				</tr>
				<tr v-if="!datalist.length && !loading">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
				<tr v-if="loading">
					<td colspan="8" class="text-center padding">加载中...</td>
				</tr>
				</tbody>
			</table>
		</div>
	</Modal>
</template>

<script>
	export default {
		name: 'SubjectDetailed',
		props: {
			subject: Object,
			accountDate: [String, Date],
			//跨月查询时的截止日期(YYYY-MM-DD)，为空表示单月
			endAccountDate: String
		},
		data() {
			return {
				show: false,
				loading: false,
				datalist: []
			};
		},
		watch: {
			show(val) {
				if (val && this.subject) {
					this.loadData();
				}
			}
		},
		methods: {
			open() {
				this.show = true;
			},
			loadData() {
				if (!this.subject) return;
				this.loading = true;
				this.$api.accountbook.loadVoucherDetails({
					accountDate: this.accountDate,
					subjectId: this.subject.id || this.subject.subjectId,
					showNumPrice: false,
					subjectCode: this.subject.code,
					endAccountDate: this.endAccountDate || undefined
				}).then(({data}) => {
					this.datalist = data;
				}).finally(() => {
					this.loading = false;
				});
			}
		}
	};
</script>
